import { render, staticRenderFns } from "./Label_YTB_Dialog.vue?vue&type=template&id=9fafc46c&"
import script from "./Label_YTB_Dialog.vue?vue&type=script&lang=js&"
export * from "./Label_YTB_Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports